import * as _ from 'lodash';
import * as React from 'react';
import { Col, Row } from 'reactstrap';
import { IFile } from 'src/model';
import {
  deleteProjectFile,
  deletePropositionFile,
  getProjectFileUrl,
  getPropositionFileUrl,
  uploadProjectFile,
  uploadPropositionFile,
} from 'src/services';
import { Svg } from '../Svg';
import { FileInput } from './FileInput';
import { FileItem } from './FileItem';

interface IFileListProps {
  edit: boolean;
  files: IFile[];
  id: string;
  type: 'project' | 'proposition';
  handleFilesUpdate: (files: IFile[]) => void;
}

export const FileList: React.SFC<IFileListProps> = ({
  edit,
  files,
  id,
  type,
  handleFilesUpdate,
}) => {
  const handleFileUpload = async (file: any) => {
    const uploadedFile = await uploadFile(file);
    if (uploadedFile) {
      files.push(uploadedFile);
      handleFilesUpdate(files);
    }
  };

  const handleFileDelete = async (fileUuid: string) => {
    const deletedFile = await deleteFile(fileUuid);
    if (deletedFile) {
      const deletedFileIndex = _.findIndex(files, { uuid: deletedFile.uuid });
      files.splice(deletedFileIndex, 1);
      handleFilesUpdate(files);
    }
  };

  const uploadFile = (file: any) =>
    type === 'project'
      ? uploadProjectFile(id, file)
      : uploadPropositionFile(id, file);

  const getFileUrl = (fileUuid: string) =>
    type === 'project'
      ? getProjectFileUrl(id, fileUuid)
      : getPropositionFileUrl(id, fileUuid);

  const deleteFile = (fileUuid: string) =>
    type === 'project'
      ? deleteProjectFile(id, fileUuid)
      : deletePropositionFile(id, fileUuid);

  return (
    <>
      <Row>
        <Col xs='auto' className='d-flex align-items-center'>
          <Svg width={24} height={24} fill='dark' src='attachment' />
          <span className='d-block font-weight-bolder ml-2'>
            Pièces jointes
          </span>
        </Col>
      </Row>
      <Row className='pt-3'>
        {files.map((file: IFile, key: number) => (
          <Col key={key} xs='4'>
            <FileItem
              edit={edit}
              file={file}
              getFileUrl={getFileUrl}
              handleFileDelete={handleFileDelete}
            />
          </Col>
        ))}
        {edit && (
          <Col xs='4'>
            <FileInput handleFileUpload={handleFileUpload} />
          </Col>
        )}
      </Row>
    </>
  );
};



// WEBPACK FOOTER //
// ./src/components/shared/Files/FileList.tsx